import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import Categories from "./components/Categories";
import Feed from "./components/Feed";
import Guide from "./components/Guide";
import Faq from "./components/Faq";
import Reviews from "./components/Reviews";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <HotRank />
        <Categories />
        <Feed />
        <Guide />
        <Faq />
        <Reviews />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}